import { render } from "./SidebarGeneral.vue?vue&type=template&id=4ed215fe&ts=true"
import script from "./SidebarGeneral.vue?vue&type=script&lang=ts"
export * from "./SidebarGeneral.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__